import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, ShoppingCart, ShoppingBag, Box, Users, History, Trash2, BarChart3, Upload, Landmark, Wallet, Globe, Truck, Briefcase, UserCircle } from 'lucide-react';
import { useRole } from './RoleContext';

const Sidebar = () => {
  const location = useLocation();
  const { isFullAccess } = useRole();

  const menuItems = [
    { name: 'Home', icon: <Home size={20} />, path: '/' },
    { name: 'Sales', icon: <ShoppingCart size={20} />, path: '/sales' },
    { name: 'Website Orders', icon: <Globe size={20} />, path: '/website-orders' },
    { name: 'Purchase', icon: <ShoppingBag size={20} />, path: '/purchase' },
    { name: 'Product Setup', icon: <Landmark size={20} />, path: '/saree-setup' },
    { name: 'Accounts', icon: <History size={20} />, path: '/accounts' },
    { name: 'Due', icon: <Wallet size={20} />, path: '/due' },
    ...(isFullAccess ? [{ name: 'HR', icon: <Briefcase size={20} />, path: '/hr' }] : []),
    { name: 'My Profile', icon: <UserCircle size={20} />, path: '/my-profile' },
    { name: 'Courier', icon: <Truck size={20} />, path: '/courier' },
    { name: 'Stock', icon: <Box size={20} />, path: '/stock' },
    { name: 'Contacts', icon: <Users size={20} />, path: '/contacts' },
    { name: 'Recycle Bin', icon: <Trash2 size={20} />, path: '/recycle-bin' },
    { name: 'Reports', icon: <BarChart3 size={20} />, path: '/reports' },
    { name: 'Product Return', icon: <History size={20} />, path: '/returns' },
    { name: 'Import Data', icon: <Upload size={20} />, path: '/import' },
  ];

  return (
    <div className="sidebar" style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <Link to="/" className="sidebar-header" style={{ display: 'block', textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}>
        <h1 style={{ fontSize: '24px', margin: 0 }}>KIZUNA</h1>
        <p style={{ fontSize: '10px', opacity: 0.8, letterSpacing: '1px' }}>INVENTORY PRO MANAGER</p>
      </Link>
      
      <nav style={{ flex: 1, marginTop: '20px' }}>
        {menuItems.map((item) => (
          <Link 
            key={item.name} 
            to={item.path} 
            className={`menu-item ${location.pathname === item.path ? 'active' : ''}`}
          >
            {item.icon} <span style={{ marginLeft: '12px' }}>{item.name}</span>
          </Link>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;